// Imports
import styled from "styled-components";

// Types
interface ButtonWrapperProps {
  gap?: string;
  marginLeft?: string;
  marginTop?: string;
}

// Styled Components
export const StoryWrapper = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const StyledButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  gap: ${(props) => props.gap || "20px"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  margin-top: ${(props) => props.marginTop || "0px"};
`;
